import { render, staticRenderFns } from "./Subject.vue?vue&type=template&id=10e938de&scoped=true"
import script from "./Subject.vue?vue&type=script&lang=js"
export * from "./Subject.vue?vue&type=script&lang=js"
import style0 from "./Subject.vue?vue&type=style&index=0&id=10e938de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e938de",
  null
  
)

export default component.exports